<template>
  <div class="text-center">
    <h1
      class="
        text-2xl tracking-tight font-black text-gray-900 sm:text-3xl
      "
    >
      <span>Success,</span>
      <span class="text-mygrad">we're all set!</span>
    </h1>
    <p
      class="
        mt-3 max-w-md mx-auto text-sm text-gray-700 sm:text-base md:mt-5 md:max-w-3xl
      "
    >
      Thank you for purchasing your Personalised GraduationClip. We'll
      send an email to {{ email }} with further information after your
      ceremony.
    </p>
  </div>
</template>
  
<script>
export default {
  name: 'MyGraduationClipSuccessMessage',
  props: {
      email: String
  }
};
</script>